export abstract class _DetailPage { }



// WEBPACK FOOTER //
// ./src/pages/_DetailPage.ts